export const replacePlaceholder = (
  templateString: string,
  dataObject: Record<string, string | number>
) => {
  if (typeof templateString !== 'string' || typeof dataObject !== 'object' || dataObject === null) {
    // In a real-world scenario, you might throw an error instead of logging.
    // For these tests, we'll keep the original behavior of returning the template string.
    return templateString;
  }

  const regex = /{{\s*([\w.-]+)\s*}}/g;

  return templateString.replace(regex, (match, key) => {
    if (Object.hasOwn(dataObject, key)) {
      return dataObject[key]?.toString();
    }

    return match;
  });
};
